import { render } from "./reporteavancegeneral.vue?vue&type=template&id=506fc254"
import script from "./reporteavancegeneral.vue?vue&type=script&lang=js"
export * from "./reporteavancegeneral.vue?vue&type=script&lang=js"

import "./reporteavancegeneral.vue?vue&type=style&index=0&id=506fc254&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-cliente-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__